export default __webpack_public_path__ + "static/media/webfortune.7926da48.png";